/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';

import constants from '../../utils/constants';
import PlpContext from '../../templates/Plp/context';

const Privacy = () => {
  const {
    sites: { us },
  } = constants;

  return (
    <PlpContext.Consumer>
      {({ template = '' } = {}) => (
        <section className="power-privacy">
          <div className="four-column">
            <div className="column">
              <p>
                {`Copyright © ${new Date().getFullYear()} Kabbage, Inc. All rights
            reserved.${
              template !== 'SbaPost'
                ? ' Kabbage Funding™ is a trademark of Kabbage, Inc., used under license.'
                : ''
            }`}
              </p>
            </div>
            <div className="column">
              {template !== 'SbaPost' ? (
                <p>
                  All Kabbage Funding&trade; business loans are issued by Celtic
                  Bank, a Utah-Chartered Industrial Bank, Member FDIC.
                </p>
              ) : (
                <>&nbsp;</>
              )}
            </div>
            <div className="column">&nbsp;</div>
            <div className="column">
              <a
                href="http://www.innovativelending.org/"
                target="_blank"
                className="ilpa-footer"
                style={{
                  float: 'none',
                  margin: '10px 0 0',
                  backgroundPosition: '0 0',
                  width: '95px',
                  height: '45px',
                }}
              />
              <a
                href="http://www.bbb.org/atlanta/business-reviews/financing-consultants/kabbage-in-atlanta-ga-27469815"
                target="_blank"
                className="bbb-footer"
                style={{
                  float: 'none',
                  margin: '10px 0 0',
                  backgroundPositionX: '4px',
                }}
              >
                BBB
              </a>
              <a
                href={`https://${us}/smart-box/`}
                className="smartbox-footer"
                style={{
                  float: 'none',
                  margin: '10px 0 0',
                  width: '95px',
                  backgroundPosition: '0 0',
                }}
              />
              <a
                href="//privacy.truste.com/privacy-seal/validation?rid=351f4dc2-a0ad-4478-92ce-c9186d02b21b"
                target="_blank"
                style={{ margin: '10px 0 0' }}
              >
                <img
                  style={{ border: 'none', textIndent: '0', display: 'block' }}
                  src="//privacy-policy.truste.com/privacy-seal/seal?rid=351f4dc2-a0ad-4478-92ce-c9186d02b21b"
                  alt="TRUSTe"
                />
              </a>
            </div>
          </div>
          <div className="terms-site-map">
            <div className="column bottom-links">
              <ul>
                <li>
                  <a href={`https://${us}/company/legal/#tos`}>
                    Terms of Service
                  </a>
                </li>
                <li className="map-link">
                  <a href={`https://${us}/company/legal/`}>Privacy Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </section>
      )}
    </PlpContext.Consumer>
  );
};

export default Privacy;
